import React from "react";
import GrossMarginLevelListForm from './list/GrossMarginLevelListForm';
import EditGrossMarginLevelForm from './edit/EditGrossMarginLevelForm'

const GrossMarginLevelView = ({ displayList }) => {
  return displayList ? (
    <GrossMarginLevelListForm />
  ) : (
    <EditGrossMarginLevelForm />
  );
};

export default GrossMarginLevelView;
